angular.module('tuitionFeesModule')
    .component('invoiceDetailViewCreditNotes', {
        bindings: {
            invoiceCreditNotes : '<'
        },
        templateUrl: '/Scripts/app/tuitionFees/components/invoice/invoice-detail-view-credit-notes.template.html',
        controller: class InvoiceDetailViewCreditNotesCtrl {

            // bindings
            invoiceCreditNotes: any[];

            // dependencies
            $window: any;
            invoiceService: any;

            // variables
            currencyDisplaySymbol: string;
            currencyExponent: number;
            showNoResult: boolean;
            sortReverse: boolean = true;
            sortType: string = 'dateIssued';
            downloadingCreditNoteId: number | null = null;

            static $inject = ['$window', 'invoiceService'];

            constructor($window, invoiceService)
            {
                this.$window = $window;
                this.invoiceService = invoiceService;
                this.showNoResult = false;

                this.currencyDisplaySymbol = $window.EveryBuddy.Constants.CurrencyDisplaySymbol;
                this.currencyExponent = $window.EveryBuddy.Constants.CurrencyExponent;
            }

            $onChanges(changes) {
                if (changes.invoiceCreditNotes?.currentValue) {
                    this.showNoResult = !changes.invoiceCreditNotes?.currentValue || changes.invoiceCreditNotes?.currentValue?.length == 0;
                }
            }

            // Each successful download writes an OrganisationPDFAudit row, so a double click
            // must not fire a second request (SB-16454).
            downloadCreditNote(item) {
                if (this.downloadingCreditNoteId !== null || !item?.pdfBlobPath) {
                    return;
                }

                this.downloadingCreditNoteId = item.id;
                this.invoiceService.downloadPdf(item.pdfBlobPath, `CreditNote-${item.id}.pdf`)
                    .finally(() => {
                        this.downloadingCreditNoteId = null;
                    });
            }
        }
    });
